import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import Tooltip from '../../../../Components/Popup/Tooltip';

interface Props {
	trigger: React.ReactNode;
}

const ElectronicSignatureTimestampUnavailableTooltip: React.FC<Props> = ({
	trigger,
}) => {
	return (
		<Tooltip trigger={trigger}>
			<Text
				tx='component.electronicSignatureUnavailableTooltip.message'
				inline
			/>
		</Tooltip>
	);
};

export default ElectronicSignatureTimestampUnavailableTooltip;
